export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export function track(event, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", event, params);
  }
}

export const trackCompleteRegistration = () =>
  track("CompleteRegistration", { status: true });

export const trackLead = () => track("Lead");

export function trackPurchase(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return;
  track("Purchase", { value: amount, currency: "EUR" });
}
